import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { gridDefaultV0Schema } from './v0';
import { gridLegacySchema } from '../legacy/schema';
import { migrateLegacyDefaultToV0 } from '../legacy/migration';

export const DefaultGridEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: gridDefaultV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: gridLegacySchema, up: migrateLegacyDefaultToV0 }],
});

export type DefaultGrid = InferredEntity<typeof DefaultGridEntitySchema>;
